import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { talkUiLng } from '@/utils/talkWelt'

export function useTalkT() {
  const { t } = useTranslation()
  const lng = talkUiLng()
  return useCallback(
    (key: string, options?: Record<string, unknown>) => String(t(key, { lng, ...options })),
    [t, lng],
  )
}
